module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Falk er riktig.1d976611.mp3";